import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Location.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { useGetLocationList } from '../api/getLocations';
import { ArchiveIcon } from '@heroicons/react/outline';
import {  Location, UserRole, State } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { Loader } from '@/components/Loader/Loader';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Filter, { ReactComponent as FilterIcon } from '@/assets/steam/filter.svg';
import Delete from '@/assets/steam/delete.svg';
import View from '@/assets/steam/view.svg';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import AddNewUser from '../components/addNewLocation';
import { useGetStateList, useGetUserRoleList } from '../api/getRefrences';
import { FilterMenu } from '@/components/Elements/FilterMenu';
import AddNewLocation from '../components/addNewLocation';

export const Locations = () => {
  const [locationList, setLocationsList] = useState<Location[]>([]);
  const [isAddNewLocation, setIsAddNewLocation] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<Location[]>([]);
  const [productDetails, setProductDetails] = useState<Location>();
  const useGetUsersMutation = useGetLocationList();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [editLocationData, setEditLocationData] = useState<any>(null);

  useEffect(() => {
    getLocationsList(1, true);
  }, []);


  const getLocationsList = async (pageIndex: number, reset = false, filter?: any, isOnlyEdit?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if(isOnlyEdit){
      setLocationsList(res.list);
      if(pageIndex)setTableCurrentIndex(pageIndex);
      if (searchString) {
        setFilteredList(res.list);
      }
    }else 
    if (reset) {
      setLocationsList(res.list);
      if(pageIndex){
        setTableCurrentIndex(pageIndex);
      }else{
        setTableCurrentIndex(tableCurrentIndex);
      }
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setLocationsList(locationList.concat(res.list));
      if(pageIndex){
        setTableCurrentIndex(pageIndex);
      }else{
        setTableCurrentIndex(tableCurrentIndex);
      }
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetUsersMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setLocationsList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : locationList;

  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getLocationsList(pageIndex, true);
    }
  };

  return (
    <>

      <div className="users-list-container">
        <PageHeader title='Location Management' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search by state..."
                onChange={searchUser}
                className="steam-search"
              />
            </span>
            <div>
           
            </div>

          </div>
          <div className='add-user-container'>
            {/* <button className='steam-button button-dark' onClick={() => { setIsAddNewLocation(true) }}>+ Add new location</button> */}

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<Location>
            data={actualList}
            columns={[
              {
                title: 'State',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="users-container">
                      <div>
                        <InitialsAvatar name={entry && entry.name ? entry.name : 'SA'} className="avatar" />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name">
                          <div className="name">{entry?.name}</div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                title: 'City',
                field: 'name',
                Cell({ entry: { city } }) {
                  const { firstTenCity, remainingCount } = Utils.getOnly10CITY(city);
                  return (
                    <div className="table-contact">
                      <div className='location-city-width'>
                      {firstTenCity.join(', ')}
                      </div>
                                                {remainingCount > 0 && (
                      <span className='show-count'>
                        +{remainingCount}
                      </span>
                    )}

                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">
                     
                      <div className="edit-btn" onClick={() => { setEditLocationData(entry); setIsAddNewLocation(true) }} >
                        <img src={Edit} />
                      </div>
                      <div
                        className="view-btn"
                        onClick={() => {
                         // deleteUser(entry.id)
                        }}
                      >
                        <img src={Delete} />
                      </div>
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>

        <AddNewLocation onConfirm={() => {setIsAddNewLocation(false);getLocationsList(tableCurrentIndex, false, null, true) }} onClose={() => { setIsAddNewLocation(false); setEditLocationData(null) }} open={isAddNewLocation} editLocationData={editLocationData} />


      </div>

    </>
  );
};
